<template>
  <div>
    <v-alert v-if="!novo" type="info" outlined>
      A edição de cliente ainda não foi implementada.
      <div class="mt-3">
        <v-btn small text @click="voltar()">
          <v-icon left small>mdi-arrow-left</v-icon>Voltar para a lista
        </v-btn>
      </div>
    </v-alert>

    <v-stepper v-else v-model="etapa" class="elevation-1">
      <v-stepper-header>
        <v-stepper-step :complete="etapa > 1" step="1">
          Dados do cliente
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="!!criado" step="2">
          Endereço principal
        </v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <!-- 1. dados do cliente -->
        <v-stepper-content step="1">
          <v-card outlined>
            <v-card-title class="subtitle-1">
              Identificação
              <v-spacer></v-spacer>
              <v-chip v-if="tipoPessoa" small outlined color="info">
                {{ tipoPessoa }}
              </v-chip>
            </v-card-title>
            <v-card-text>
              <p class="body-2 grey--text text--darken-1">
                Informe o CPF/CNPJ para verificar se o cliente já possui
                cadastro.
              </p>
              <v-form ref="formConsulta" @submit.prevent="consultar()">
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      label="CPF/CNPJ"
                      v-model="cpfCnpj"
                      :rules="[obrigatorio, documentoValido]"
                      :disabled="consultando || situacao !== null"
                      prepend-inner-icon="mdi-card-account-details-outline"
                      maxlength="18"
                      hint="Digite apenas os números"
                      persistent-hint
                      outlined
                      dense
                      autofocus
                      @keyup.enter="consultar()"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="8" class="d-flex align-start">
                    <v-btn
                      color="primary"
                      :loading="consultando"
                      :disabled="situacao !== null"
                      @click="consultar()"
                    >
                      <v-icon left>mdi-magnify</v-icon>Consultar
                    </v-btn>
                    <v-btn
                      class="ml-2"
                      text
                      :disabled="consultando"
                      @click="limpar()"
                    >
                      Limpar
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>

              <!-- resultado: cliente ja cadastrado -->
              <v-alert
                v-if="situacao === 'existente'"
                type="warning"
                outlined
                class="mb-0"
              >
                Já existe um cliente cadastrado com este CPF/CNPJ.
                <div v-if="encontrado && encontrado.nome" class="font-weight-medium mt-1">
                  {{ encontrado.nome }}
                </div>
                <div class="mt-3">
                  <v-btn small text @click="limpar()">Consultar outro</v-btn>
                </div>
              </v-alert>

              <!-- resultado: liberado para cadastrar -->
              <v-alert
                v-if="situacao === 'novo'"
                type="success"
                outlined
                class="mb-0"
              >
                Nenhum cliente encontrado com este CPF/CNPJ. Pode seguir com o
                cadastro.
                <div class="mt-3">
                  <v-btn small text @click="limpar()">Consultar outro</v-btn>
                </div>
              </v-alert>
            </v-card-text>
          </v-card>

          <v-card v-if="situacao === 'novo'" outlined class="mt-4">
            <v-card-title class="subtitle-1">Dados cadastrais</v-card-title>
            <v-card-text>
              <v-form ref="formCliente">
                <v-row dense>
                  <v-col cols="12" md="8">
                    <v-text-field
                      :label="labelNome"
                      v-model="cliente.nome"
                      :rules="[obrigatorio]"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      label="Nome fantasia"
                      v-model="cliente.nomeFantasia"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      label="CPF/CNPJ"
                      :value="cpfCnpj"
                      disabled
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      :label="labelRegistro"
                      v-model="cliente.registro"
                      :hint="hintRegistro"
                      maxlength="20"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      :label="labelData"
                      v-model="cliente.dataNascimento"
                      :rules="[dataValida]"
                      placeholder="dd/mm/aaaa"
                      maxlength="10"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-text-field
                      label="E-mail"
                      v-model="cliente.email"
                      :rules="[emailValido]"
                      prepend-inner-icon="mdi-email-outline"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-text-field
                      label="Telefone"
                      v-model="cliente.telefone"
                      :rules="[telefoneValido]"
                      prepend-inner-icon="mdi-phone-outline"
                      maxlength="15"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-text-field
                      label="Celular"
                      v-model="cliente.celular"
                      :rules="[telefoneValido]"
                      prepend-inner-icon="mdi-cellphone"
                      maxlength="15"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-textarea
                      label="Observação"
                      v-model="cliente.observacao"
                      rows="3"
                      auto-grow
                      outlined
                      dense
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>

          <div class="mt-4 d-flex">
            <v-btn text @click="voltar()">
              <v-icon left small>mdi-arrow-left</v-icon>Cancelar
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              :disabled="situacao !== 'novo'"
              @click="continuar()"
            >
              Continuar<v-icon right>mdi-arrow-right</v-icon>
            </v-btn>
          </div>
        </v-stepper-content>

        <!-- 2. endereco principal: grava o cadastro inteiro num POST so -->
        <v-stepper-content step="2">
          <!-- gravado -->
          <div v-if="criado">
            <v-alert type="success" outlined>
              Cliente cadastrado no compels.
              <div class="font-weight-medium mt-1">{{ resumoCriado }}</div>
              <div v-if="detalheCriado" class="body-2 mt-1">
                {{ detalheCriado }}
              </div>
            </v-alert>
            <div class="mt-4 d-flex">
              <v-btn text @click="novoCadastro()">
                <v-icon left small>mdi-account-plus</v-icon>Cadastrar outro
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="voltar()">Ir para a lista</v-btn>
            </div>
          </div>

          <!-- endereco + gravacao -->
          <div v-else>
            <v-alert v-if="erro" type="error" outlined dense>
              {{ erro }}
            </v-alert>
            <v-card outlined>
              <v-card-title class="subtitle-1">
                Endereço principal
                <v-spacer></v-spacer>
                <span class="body-2 grey--text text--darken-1">
                  {{ cliente.nome }}
                </span>
              </v-card-title>
              <v-card-text>
                <p class="body-2 grey--text text--darken-1">
                  O CEP precisa estar cadastrado no compels — é ele que define o
                  município. Ao completar o CEP o endereço é consultado e preenchido.
                </p>
                <v-form ref="formEndereco">
                  <v-row dense>
                    <v-col cols="12" sm="4" md="3">
                      <v-text-field
                        label="CEP"
                        v-model="endereco.cep"
                        :rules="[obrigatorio, cepCompleto]"
                        :error-messages="cepErro"
                        :loading="cepConsultando"
                        prepend-inner-icon="mdi-map-marker-outline"
                        maxlength="9"
                        outlined
                        dense
                        @blur="consultarCep()"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="8" md="9">
                      <v-text-field
                        label="Logradouro"
                        v-model="endereco.endereco"
                        :rules="[obrigatorio]"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="3">
                      <v-text-field
                        label="Número"
                        v-model="endereco.numero"
                        :rules="[obrigatorio]"
                        maxlength="10"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="8" md="9">
                      <v-text-field
                        label="Complemento"
                        v-model="endereco.complemento"
                        maxlength="60"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="8" md="6">
                      <v-text-field
                        label="Bairro"
                        v-model="endereco.bairro"
                        :rules="[obrigatorio]"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="6">
                      <v-text-field
                        label="Cidade"
                        :value="cidadeUf"
                        hint="Definida pelo CEP no compels"
                        persistent-hint
                        readonly
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
            </v-card>

            <div class="mt-4 d-flex">
              <v-btn text :disabled="salvando" @click="etapa = 1">
                <v-icon left small>mdi-arrow-left</v-icon>Voltar
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="success" :loading="salvando" @click="salvar()">
                <v-icon left>mdi-content-save</v-icon>Salvar cadastro
              </v-btn>
            </div>
          </div>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
import api from "../../api/index.js";
import router from "../../router/index.js";

// tipo do telefone no compels: 0 = telefone, 1 = celular, 2 = fax
var TIPO_TELEFONE = 0;
var TIPO_CELULAR = 1;

// o backend nao recebe string vazia nos campos opcionais
function ouNulo(valor) {
  var v = (valor || "").trim();
  return v ? v : null;
}

// a api sobe a causa do compels no "message" do corpo do erro
function mensagemErro(error, padrao) {
  var dados = error && error.response ? error.response.data : null;
  if (dados) {
    if (typeof dados === "string" && dados.trim()) return dados;
    if (dados.message) return dados.message;
  }
  return padrao;
}

function clienteVazio() {
  return {
    nome: "",
    nomeFantasia: "",
    // rg (pessoa fisica) ou inscricao estadual (juridica): a api escolhe
    // onde gravar pelo numero de digitos do documento
    registro: "",
    email: "",
    telefone: "",
    celular: "",
    dataNascimento: "",
    observacao: "",
  };
}

function enderecoVazio() {
  return {
    cep: "",
    endereco: "",
    numero: "",
    complemento: "",
    bairro: "",
  };
}

export default {
  data: function () {
    return {
      etapa: 1,
      cpfCnpj: "",
      consultando: false,
      // null = ainda nao consultado | "novo" | "existente"
      situacao: null,
      // cliente devolvido pela consulta, quando ja existir
      encontrado: null,
      cliente: clienteVazio(),
      endereco: enderecoVazio(),
      // consulta do cep: null = nao consultado | "ok" | "inexistente" | "falha"
      cepStatus: null,
      cepConsultando: false,
      // ultimo cep consultado, para nao repetir a chamada a cada tecla
      cepConsultado: "",
      // resposta do GET /cep/{codigo}, de onde sai a cidade
      cepInfo: null,
      cepTimer: null,
      salvando: false,
      // resposta do POST /client, que grava cliente, telefones e endereco
      criado: null,
      erro: null,
    };
  },
  computed: {
    novo: function () {
      return this.$route.params.id === "0";
    },
    digitos: function () {
      return this.somenteDigitos(this.cpfCnpj);
    },
    pessoaJuridica: function () {
      return this.digitos.length === 14;
    },
    tipoPessoa: function () {
      if (this.digitos.length === 11) return "Pessoa física";
      if (this.pessoaJuridica) return "Pessoa jurídica";
      return null;
    },
    labelNome: function () {
      return this.pessoaJuridica ? "Razão social" : "Nome completo";
    },
    labelData: function () {
      return this.pessoaJuridica ? "Data de fundação" : "Data de nascimento";
    },
    labelRegistro: function () {
      return this.pessoaJuridica ? "Inscrição estadual" : "RG";
    },
    hintRegistro: function () {
      return this.pessoaJuridica ? "Informe ISENTO quando não houver" : null;
    },
    cepErro: function () {
      if (this.cepStatus === "inexistente") {
        return "CEP não cadastrado no compels — cadastre-o lá antes de gravar o cliente.";
      }
      if (this.cepStatus === "falha") return "Falha ao consultar o CEP.";
      return [];
    },
    cidadeUf: function () {
      var info = this.cepInfo;
      if (!info || !info.cidade) return "";
      return info.uf ? info.cidade + " / " + info.uf : info.cidade;
    },
    resumoCriado: function () {
      var dados = this.criado || {};
      var nome = dados.nome || this.cliente.nome;
      return dados.codigo ? dados.codigo + " - " + nome : nome;
    },
    detalheCriado: function () {
      var dados = this.criado || {};
      var partes = [];
      var fones = dados.telefones ? dados.telefones.length : 0;
      if (fones === 1) partes.push("1 telefone");
      if (fones > 1) partes.push(fones + " telefones");
      if (dados.enderecoId) partes.push("endereço principal");
      return partes.length ? "Gravados também: " + partes.join(" e ") + "." : null;
    },
  },
  watch: {
    cpfCnpj: function (valor) {
      var formatado = this.formatar(valor);
      if (formatado !== valor) this.cpfCnpj = formatado;
    },
    "cliente.telefone": function (valor) {
      var formatado = this.formatarTelefone(valor);
      if (formatado !== valor) this.cliente.telefone = formatado;
    },
    "cliente.celular": function (valor) {
      var formatado = this.formatarTelefone(valor);
      if (formatado !== valor) this.cliente.celular = formatado;
    },
    "cliente.dataNascimento": function (valor) {
      var formatado = this.formatarData(valor);
      if (formatado !== valor) this.cliente.dataNascimento = formatado;
    },
    "endereco.cep": function (valor) {
      var formatado = this.formatarCep(valor);
      // a mascara reentra no watcher: a consulta sai na segunda passada
      if (formatado !== valor) {
        this.endereco.cep = formatado;
        return;
      }
      this.agendarConsultaCep();
    },
  },
  methods: {
    consultar: function () {
      if (!this.$refs.formConsulta.validate()) return;
      var me = this;
      me.consultando = true;
      me.situacao = null;
      me.encontrado = null;

      var token = localStorage.getItem("token");
      api
        .post(
          "/client/documento",
          { documento: me.digitos },
          { headers: { Authorization: "Bearer " + token } }
        )
        .then(function (response) {
          // { result: true, nome: "..." } = documento ja cadastrado
          var dados = response.data || {};
          me.encontrado = dados.result ? dados : null;
          me.situacao = me.encontrado ? "existente" : "novo";
        })
        .catch(function (error) {
          console.log(error);
          alert("Falha ao consultar CPF/CNPJ!");
        })
        .then(function () {
          me.consultando = false;
        });
    },
    continuar: function () {
      if (!this.$refs.formCliente.validate()) return;
      this.erro = null;
      this.etapa = 2;
    },
    // cliente, telefones e endereco principal vao num POST /client so: no
    // compels sao tres recursos, e quem encadeia a criacao e a api
    salvar: function () {
      this.erro = null;
      if (this.$refs.formCliente && !this.$refs.formCliente.validate()) {
        this.etapa = 1;
        return;
      }
      if (!this.$refs.formEndereco.validate()) return;
      if (this.cepConsultando) {
        this.erro = "Aguarde a consulta do CEP.";
        return;
      }
      if (this.cepStatus === "inexistente") {
        this.erro =
          "CEP não cadastrado no compels. Cadastre o CEP antes de gravar o cliente.";
        return;
      }
      var me = this;
      me.salvando = true;

      var token = localStorage.getItem("token");
      api
        .post(
          "/client",
          {
            nome: ouNulo(me.cliente.nome),
            nomeFantasia: ouNulo(me.cliente.nomeFantasia),
            // o compels grava o documento com mascara: vai como esta na tela
            documento: me.cpfCnpj,
            registro: ouNulo(me.cliente.registro),
            email: ouNulo(me.cliente.email),
            nascimento: me.dataIso(me.cliente.dataNascimento),
            observacao: ouNulo(me.cliente.observacao),
            telefones: me.telefones(),
            endereco: {
              cep: me.endereco.cep,
              endereco: ouNulo(me.endereco.endereco),
              numero: ouNulo(me.endereco.numero),
              complemento: ouNulo(me.endereco.complemento),
              bairro: ouNulo(me.endereco.bairro),
            },
          },
          { headers: { Authorization: "Bearer " + token } }
        )
        .then(function (response) {
          me.criado = response.data || {};
        })
        .catch(function (error) {
          console.log(error);
          me.erro = mensagemErro(
            error,
            "Falha ao cadastrar o cliente. Confira os dados e o CEP e tente novamente."
          );
        })
        .then(function () {
          me.salvando = false;
        });
    },
    // a consulta sai sozinha quando o usuario termina de digitar o cep
    agendarConsultaCep: function () {
      var me = this;
      if (me.cepTimer) clearTimeout(me.cepTimer);
      var digitos = me.digitosCep();
      if (digitos.length < 8) {
        me.limparCep();
        return;
      }
      if (digitos === me.cepConsultado) return;
      me.cepTimer = setTimeout(function () {
        me.consultarCep();
      }, 500);
    },
    // GET /cep/{codigo} -> { result, logradouro, bairro, cidade, uf, ... }
    // result false = cep fora da tabela do compels, que e quem recusa o cadastro
    consultarCep: function () {
      var me = this;
      if (me.cepTimer) {
        clearTimeout(me.cepTimer);
        me.cepTimer = null;
      }
      var digitos = me.digitosCep();
      if (digitos.length < 8 || me.cepConsultando) return;
      if (digitos === me.cepConsultado && me.cepStatus === "ok") return;

      // o endereco na tela veio de um cep anterior, e nao do usuario
      var preenchido = !!me.cepInfo;
      me.cepConsultando = true;
      me.cepStatus = null;
      me.cepInfo = null;

      var token = localStorage.getItem("token");
      api
        // o compels grava o cep com mascara: vai como esta na tela
        .get("/cep/" + me.endereco.cep, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          var dados = response.data || {};
          me.cepConsultado = digitos;
          if (!dados.result) {
            me.cepStatus = "inexistente";
            // o que veio do cep anterior nao vale mais
            if (preenchido) {
              me.endereco.endereco = "";
              me.endereco.bairro = "";
            }
            return;
          }
          me.cepStatus = "ok";
          me.cepInfo = dados;
          // quando o cep nao traz o campo (cep unico de cidade) fica o que o
          // usuario digitou, a menos que fosse valor de um cep anterior
          me.endereco.endereco = me.doCep(dados.logradouro, me.endereco.endereco, preenchido);
          me.endereco.bairro = me.doCep(dados.bairro, me.endereco.bairro, preenchido);
        })
        .catch(function (error) {
          console.log(error);
          // deixa repetir a consulta quando foi falha de rede
          me.cepConsultado = "";
          me.cepStatus = "falha";
        })
        .then(function () {
          me.cepConsultando = false;
        });
    },
    doCep: function (retornado, atual, preenchido) {
      if (retornado) return retornado;
      return preenchido ? "" : atual;
    },
    limparCep: function () {
      this.cepStatus = null;
      this.cepInfo = null;
      this.cepConsultado = "";
    },
    digitosCep: function () {
      return (this.endereco.cep || "").replace(/\D/g, "").substring(0, 8);
    },
    // telefone e celular sao dois registros do recurso telefone no compels
    telefones: function () {
      var lista = [];
      if (this.cliente.telefone) {
        lista.push({ telefone: this.cliente.telefone, tipo: TIPO_TELEFONE });
      }
      if (this.cliente.celular) {
        lista.push({ telefone: this.cliente.celular, tipo: TIPO_CELULAR });
      }
      return lista;
    },
    // dd/mm/aaaa -> aaaa-mm-dd
    dataIso: function (valor) {
      var d = (valor || "").replace(/\D/g, "");
      if (d.length !== 8) return null;
      return (
        d.substring(4, 8) + "-" + d.substring(2, 4) + "-" + d.substring(0, 2)
      );
    },
    novoCadastro: function () {
      this.criado = null;
      this.endereco = enderecoVazio();
      this.limparCep();
      if (this.$refs.formEndereco) this.$refs.formEndereco.resetValidation();
      this.limpar();
      this.etapa = 1;
    },
    limpar: function () {
      this.cpfCnpj = "";
      this.situacao = null;
      this.encontrado = null;
      this.cliente = clienteVazio();
      this.erro = null;
      this.$refs.formConsulta.resetValidation();
    },
    voltar: function () {
      router.push({ path: "/client" });
    },
    obrigatorio: function (valor) {
      return !!valor || "Campo obrigatório";
    },
    emailValido: function (valor) {
      if (!valor) return true;
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(valor) || "E-mail inválido";
    },
    telefoneValido: function (valor) {
      if (!valor) return true;
      var d = (valor || "").replace(/\D/g, "");
      return d.length === 10 || d.length === 11 || "Número incompleto";
    },
    cepCompleto: function (valor) {
      var d = (valor || "").replace(/\D/g, "");
      return d.length === 8 || "CEP incompleto";
    },
    dataValida: function (valor) {
      if (!valor) return true;
      var d = (valor || "").replace(/\D/g, "");
      if (d.length !== 8) return "Data incompleta";
      var dia = parseInt(d.substring(0, 2), 10);
      var mes = parseInt(d.substring(2, 4), 10);
      var ano = parseInt(d.substring(4, 8), 10);
      var data = new Date(ano, mes - 1, dia);
      if (
        data.getDate() !== dia ||
        data.getMonth() !== mes - 1 ||
        data.getFullYear() !== ano
      ) {
        return "Data inválida";
      }
      return data <= new Date() || "Data no futuro";
    },
    formatarTelefone: function (valor) {
      var d = (valor || "").replace(/\D/g, "").substring(0, 11);
      if (d.length <= 2) return d ? "(" + d : "";
      // 8 digitos: (00) 0000-0000 | 9 digitos: (00) 00000-0000
      var corte = d.length > 10 ? 7 : 6;
      var out = "(" + d.substring(0, 2) + ") " + d.substring(2, corte);
      if (d.length > corte) out += "-" + d.substring(corte);
      return out;
    },
    formatarData: function (valor) {
      var d = (valor || "").replace(/\D/g, "").substring(0, 8);
      var out = d.substring(0, 2);
      if (d.length > 2) out += "/" + d.substring(2, 4);
      if (d.length > 4) out += "/" + d.substring(4, 8);
      return out;
    },
    // o compels grava o cep com mascara e o filtro casa exatamente
    formatarCep: function (valor) {
      var d = (valor || "").replace(/\D/g, "").substring(0, 8);
      if (d.length <= 5) return d;
      return d.substring(0, 5) + "-" + d.substring(5, 8);
    },
    documentoValido: function (valor) {
      var d = this.somenteDigitos(valor);
      if (d.length === 11) return this.cpfValido(d) || "CPF inválido";
      if (d.length === 14) return this.cnpjValido(d) || "CNPJ inválido";
      return "Informe 11 dígitos (CPF) ou 14 (CNPJ)";
    },
    somenteDigitos: function (valor) {
      return (valor || "").replace(/\D/g, "").substring(0, 14);
    },
    formatar: function (valor) {
      var d = this.somenteDigitos(valor);
      if (d.length <= 11) {
        var cpf = d.substring(0, 3);
        if (d.length > 3) cpf += "." + d.substring(3, 6);
        if (d.length > 6) cpf += "." + d.substring(6, 9);
        if (d.length > 9) cpf += "-" + d.substring(9, 11);
        return cpf;
      }
      var cnpj =
        d.substring(0, 2) + "." + d.substring(2, 5) + "." + d.substring(5, 8);
      cnpj += "/" + d.substring(8, 12);
      if (d.length > 12) cnpj += "-" + d.substring(12, 14);
      return cnpj;
    },
    cpfValido: function (d) {
      if (/^(\d)\1{10}$/.test(d)) return false;
      var soma = 0;
      var i;
      for (i = 0; i < 9; i++) soma += parseInt(d.charAt(i), 10) * (10 - i);
      var dv = (soma * 10) % 11;
      if (dv === 10) dv = 0;
      if (dv !== parseInt(d.charAt(9), 10)) return false;
      soma = 0;
      for (i = 0; i < 10; i++) soma += parseInt(d.charAt(i), 10) * (11 - i);
      dv = (soma * 10) % 11;
      if (dv === 10) dv = 0;
      return dv === parseInt(d.charAt(10), 10);
    },
    cnpjValido: function (d) {
      if (/^(\d)\1{13}$/.test(d)) return false;
      var pesos = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
      var digito = function (tamanho) {
        var soma = 0;
        var inicio = pesos.length - tamanho;
        for (var i = 0; i < tamanho; i++) {
          soma += parseInt(d.charAt(i), 10) * pesos[inicio + i];
        }
        var resto = soma % 11;
        return resto < 2 ? 0 : 11 - resto;
      };
      if (digito(12) !== parseInt(d.charAt(12), 10)) return false;
      return digito(13) === parseInt(d.charAt(13), 10);
    },
  },
};
</script>
